<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="preface">
<h1 style="font-family:Arial; font-size:18pt; letter-spacing:1px; padding-top:75px; padding-bottom:45px;">Preface</h1>
<p>Following on from the published play <em>My Forgotten War</em>, this latest novel <em>Hallowed Be My Name</em> centres upon a young family and the mysterious events that occur around them with the purchase of a beautiful Victorian house, in which the Stantons once lived.</p>
<p>Jonny Stanton had suffered from PWSD and mental health issues following the 1982 Falklands War conflict and the aftermath of his condition had had devastating effects on his family and friends. The house in which they had once lived has had a few unknowing buyers and occupants since the murders had taken place and none seemed to have stayed for very long. One particular family commented, “Something’s not right with that place; we have never settled, it’s as if we weren’t allowed to. Good luck to the next occupants; we’re glad to be moving on.” That place sends a chill down your spine as soon as you open the front door.</p>
<p>The house, in its Victorian summer splendour, has attracted many viewers along the way and the Harris’ thought they had bought a real bargain when their significantly lower-than-asking price was accepted. They should have taken a longer look at the property, taken in its presence, its smells and atmosphere because when you take a closer longer look, it holds many dark shadows and has a sinister breathing life pulse of its own. The house is alive!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?1d4b6b9c